/**
 * Met à jour l'attribut lang de <html> en fonction de la langue i18next active.
 * Appelé au boot et à chaque changement de langue.
 */
export function updateHtmlLang(language) {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('lang', language);
  }
}
